import {deleteMethod, getMethod, postMethod} from '~/api'

async function remove(request) {
    return await deleteMethod('/proxy/customFilters', request)
}

async function post(request) {
    return await postMethod('/proxy/customFilters', request)
}

async function get(request) {
    return await getMethod('/proxy/customFilters', request)
}

export {post, get, remove}
